import { NgModule } from '@angular/core';
import { ApiServiceProvider } from '../api/api-service';

import { PageBuilderFeaturePageProvider } from '../schema/feature-page-service';
import { PageBuilderSchemaProvider } from '../schema/schema-service';
import { PageBuilderVersionProvider } from '../version/version-service';
import { PageBuilderGlobal } from '../../providers/global';
import { PageBuilderValidation } from '../../providers/validation/v1/validation';
import { PageBuilderValidationHelper } from '../../providers/validation/v2/validation.builder';
import { PageBuilderPageNotificationProvider } from '../pagenotification/pagenotification-service';
import { PageBuilderSubmenuApiProvider } from '../menu/submenu/pagebuilder-submenu-api';
import { PageBuilderMenuProvider } from '../menu/repository';

@NgModule({
  declarations: [],
  imports: [],
  providers: [
    ApiServiceProvider,

    PageBuilderMenuProvider,
    PageBuilderFeaturePageProvider,
    PageBuilderSchemaProvider,
    PageBuilderVersionProvider,
    
    PageBuilderPageNotificationProvider,
    PageBuilderGlobal,
    PageBuilderValidation,
    PageBuilderValidationHelper,

    PageBuilderSubmenuApiProvider
  ]
})
export class BasePageBuilderModule {
}



// WEBPACK FOOTER //
// ./src/pagebuilder/services/base/base-page-builder.module.ts